import { Log } from "../../../../model/model";
import React from "react";
import { storeDate } from "../../../../utils/utils";

const iconTypeClass = {
  error: "fa-exclamation-circle",
  info: "fa-info-circle",
  warn: "fa-exclamation-triangle",
  undefined: "fa-question-circle",
};

interface LogItemProps {
  log: Log;
}

export default function LogItem(props: LogItemProps) {
  const { log } = props;
  const [open, setOpen] = React.useState(false);
  const toggleOpen = () => setOpen((prev) => !prev);
  const date = storeDate(log.date) || new Date();
  const dateString = new Date(date).toLocaleString("is", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
  return (
    <React.Fragment>
      <div className={`log-item log-icon log-icon-${log.type}`}>
        <i className={`fa ${iconTypeClass[log.type]}`}></i>
      </div>
      <div className="log-item log-date">{dateString}</div>
      <div className="log-item log-kind">{log.kind}</div>
      <div className="log-item log-log">{log.log}</div>
      {log.payload ? (
        <div className="log-item log-toggle" onClick={toggleOpen}>
          {!open && <i className="fa fa-caret-down"></i>}
          {open && <i className="fa fa-caret-up"></i>}
        </div>
      ) : (
        <div className="log-item"></div>
      )}
      <div className="log-payload">
        {open && <pre>{JSON.stringify(JSON.parse(log.payload), null, 2)}</pre>}
      </div>
    </React.Fragment>
  );
}
